<template>
  <div class="d-flex justify-content-between p-3 flex-wrap">
    <v-btn
      v-for="(alternative, key) in alternatives"
      :key="key"
      fab
      small
      outlined
      style="border: 2px solid grey; color: gray"
      :class="{ 
        'nitro text-white border-nitro': question.user_answer.toLowerCase() === alternative.toLowerCase() , 
        'cursor-default-on-hover' : disabled
      }"
      @click="disabled ? null : $emit('click', alternative)"
    >
      {{ alternative }}
    </v-btn>
  </div>
</template>
<script>
import alternatives from "@/constants/alternatives.js"
export default {
  props: {
    question: {
      type:Object,
      required:true,
    },
    disabled: {
      type:Boolean,
      default:false,
    },
  },
  data(){
    return {
      alternatives,
    }
  },
}
</script>
